import React, { useState, useEffect } from 'react';
import useAuth from '../../../hooks/useAuth';
import { serviceRequestService } from '../../../services/serviceRequestService';

const MyServiceRequests = () => {
    const { user } = useAuth();
    const [requests, setRequests] = useState([]);

    useEffect(() => {
        if (user.email) {
            fetchRequests();
        }
    }, [user.email]);

    const fetchRequests = async () => {
        try {
            const data = await serviceRequestService.getMyRequests(user.email);
            setRequests(data);
        } catch (error) {
            console.error("Failed to fetch requests", error);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to cancel this request?")) {
            try {
                await serviceRequestService.deleteRequest(id);
                fetchRequests(); // refresh list
            } catch(err) {
                console.error("Failed to cancel", err);
            }
        }
    };

    return (
        <div className="py-24 bg-slate-50 min-h-screen mt-16 px-6 sm:px-8 lg:px-10">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16">
                    <h2 className="text-4xl md:text-5xl font-black text-slate-900 tracking-tight lowercase">My <span className="text-amber-500">Service Requests</span></h2>
                    <div className="w-24 h-2 bg-amber-500 mx-auto mt-6 rounded-full shadow-lg shadow-amber-500/20"></div>
                </div>
                
                <div className="bg-white shadow-2xl rounded-[2.5rem] overflow-hidden border border-slate-100">
                    {requests.length === 0 ? (
                        <div className="py-24 text-center text-slate-400 font-medium italic">You haven't requested any services yet. Need something special?</div>
                    ) : (
                        <div className="overflow-x-auto scrollbar-hide">
                            <table className="min-w-full divide-y divide-slate-100">
                                <thead className="bg-slate-900">
                                    <tr>
                                        <th scope="col" className="px-8 py-6 text-left text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Service Name</th>
                                        <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Status</th>
                                        <th scope="col" className="px-8 py-6 text-center text-xs font-black text-amber-500 uppercase tracking-[0.2em]">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-slate-100">
                                    {requests.map((req) => (
                                        <tr key={req._id} className="hover:bg-slate-50 transition-colors group">
                                            <td className="px-8 py-6 text-sm text-slate-800 font-bold">{req.serviceTitle}</td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center">
                                                <span className={`px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest border ${req.status === 'Approved' ? 'bg-green-100 text-green-700 border-green-200' : 'bg-amber-100 text-amber-700 border-amber-200'}`}>
                                                    {req.status || 'Pending'}
                                                </span>
                                            </td>
                                            <td className="px-8 py-6 whitespace-nowrap text-center">
                                                <button 
                                                    onClick={() => handleDelete(req._id)}
                                                    className="bg-red-500/10 text-red-600 hover:bg-red-600 hover:text-white px-6 py-2.5 rounded-xl transition-all text-xs font-black uppercase tracking-widest border border-transparent hover:border-red-200 shadow-sm"
                                                >
                                                    Cancel
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyServiceRequests;
